import emit from '../../../common/events';
import store from '../../../store/store';
import { StoreState } from '../../../store/store.interface';
import { getOrderTypeFromOrderDetails, getProductTypeBU } from '../../../common/utils/analytics-util';
import { getAppFlow, getUserActiveTab } from '../../user-profile/utils/user-profile.util';
import { getAnalyticsSafeData, selectUser } from '../../user-profile/user-profile.selectors';
import { OrderHistory as IOrderHistory, UserOrderDetails } from '../../order-history/order-history.interface';
import { getOrderUiStatus } from '../../order-history/utils/order-history.util';

const INSTRUCTOR = 'Instructor';
const STUDENT = 'Student';

function getViewerType(): string {
  const user = selectUser(store.getState() as StoreState);
  return user?.userType === 'instructor' ? INSTRUCTOR : STUDENT;
}

export class SampleHistoryAnalytics {
  static load({ element, orders }: { element: Element; orders: IOrderHistory[] }): void {
    const user = selectUser(store.getState() as StoreState);

    emit({
      element,
      name: 'sample-history-load',
      detail: {
        appFlow: getAppFlow(),
        user: getAnalyticsSafeData(user!, true),
        viewerType: getViewerType(),
        orders: orders.map((order) => ({
          webOrderNo: order.webOrderNo,
          orderedDate: order.orderedDate.substring(0, 10),
          overAllOrderStatus: order.overAllOrderStatus.toString(),
          paymentType: order.paymentType,
          totalProductCount: order.totalProductCount,
          ...getOrderTypeFromOrderDetails(order),
          ...getProductTypeBU({ programIds: order.userOrderDetails.map((product) => product.programSourceId ?? '') }),
        })),
        totalOrders: orders.length,
        myAccountSection: getUserActiveTab(),
      },
      dataLayer: true,
    });
  }

  static viewOrderDetails({ element, order }: { element: Element; order: IOrderHistory }): void {
    const user = selectUser(store.getState() as StoreState);

    emit({
      element,
      name: 'view-sample-order-details',
      detail: {
        appFlow: getAppFlow(),
        user: getAnalyticsSafeData(user!, true),
        viewerType: getViewerType(),
        orderNumber: order.webOrderNo,
        orderedDate: order.orderedDate.substring(0, 10),
        overAllOrderStatus: order.overAllOrderStatus.toString(),
        myAccountSection: getUserActiveTab(),
        ...getOrderTypeFromOrderDetails(order),
      },
      dataLayer: true,
    });
  }

  static cta({
    element,
    name,
    label,
    order,
    item,
    href,
  }: {
    element: Element;
    name: string;
    label: string;
    order: IOrderHistory;
    item: UserOrderDetails;
    href?: string;
  }): void {
    const user = selectUser(store.getState() as StoreState);

    emit({
      element,
      name,
      detail: {
        orderNumber: order.webOrderNo,
        userRole: user?.persona.role,
        userSegment: user?.persona.segment,
        orderStatus: order.orderStatusText,
        productStatus: getOrderUiStatus(order, item),
        ...getOrderTypeFromOrderDetails(order),
        buttonName: label,
        isbn13: item.isbn13,
        mhid: item.mhid,
        itemType: item.itemType,
        editionOrRelease: item.editionOrRelease,
        viewerType: getViewerType(),
        ...(href && { href }),
        ...(getUserActiveTab() !== '' && { myAccountSection: getUserActiveTab() }),
      },
      dataLayer: true,
    });
  }
}
